import { storeRegister } from '@/piri/utils';

import moduleName from './moduleName';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  sites: [],
  site: {},
  selectedId: undefined,
  selected: {},
};

export default {
  namespaced: true,
  ...storeRegister,
  key: moduleName,
  state,
  getters,
  mutations,
  actions,
};
